<template>
    <header class="primary-header">
        <div class="container primary-header__container">
            <router-link
                to="/"
                class="primary-header__logo-link">
                <img
                    src="/logo.svg"
                    class="primary-header__logo">
            </router-link>
        </div>
    </header>
</template>

<script>
export default {
    name: 'PrimaryHeader'
};
</script>

<style lang="scss">
.primary-header{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $header-height-large;
    z-index: 500;
    &__container{
        height: inherit;
        max-width: $global-max-width;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
    }
    &__logo-link{
        margin-right: auto;
    }
    &__logo{
        width: 140px;
        height: auto;
    }
}
</style>
